/* BT-CUSTOM 2026-10-20: hurtigkøb på produktkort – bundark "Vælg størrelse". Porteret fra CB assets/cb-kort.js (arkByg/arkAabn/arkLuk/arkLaeg). */
import Cart from "cart-store";
let ark = null, fra = null;
function byg() {
  if (ark) return ark;
  ark = document.createElement('div'); ark.className = 'bt-ark'; ark.hidden = true;
  ark.innerHTML = '<div class="bt-ark__dim" data-bt-luk></div><div class="bt-ark__panel" role="dialog" aria-modal="true" aria-labelledby="bt-ark-titel"><div class="bt-ark__top"><p class="bt-ark__titel" id="bt-ark-titel"></p><button type="button" class="bt-ark__x" data-bt-luk><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button></div><div class="bt-ark__str"></div></div>';
  document.body.appendChild(ark); return ark;
}
function aabn(b) {
  const a = byg(), card = b.closest('product-card') || b.parentElement;
  const data = card.querySelector('.bt-qs__v'); if (!data) return;
  const vs = JSON.parse(data.textContent);
  a.querySelector('.bt-ark__titel').textContent = b.dataset.titel || '';
  a.querySelector('.bt-ark__x').setAttribute('aria-label', b.dataset.luk || 'Luk');
  const str = a.querySelector('.bt-ark__str'); str.innerHTML = '';
  vs.forEach(v => { const n = document.createElement('button'); n.type = 'button'; n.className = 'bt-ark__knap'; n.dataset.btVariant = v.id; n.textContent = v.t;
    if (!v.a) { n.disabled = true; n.setAttribute('aria-label', v.t + ' – ' + (b.dataset.sold || '')); } str.appendChild(n); });
  fra = b; document.body.appendChild(a); /* sidst i body = over cookie-banneret (samme z-index) */ a.hidden = false; document.documentElement.classList.add('bt-ark-laast');
  requestAnimationFrame(() => requestAnimationFrame(() => a.classList.add('is-aaben')));
  const f = str.querySelector('button:not([disabled])') || a.querySelector('.bt-ark__x'); f && f.focus({ preventScroll: true });
}
function luk() {
  if (!ark || ark.hidden) return;
  ark.classList.remove('is-aaben'); document.documentElement.classList.remove('bt-ark-laast');
  setTimeout(() => { if (!ark.classList.contains('is-aaben')) ark.hidden = true; }, 250);
  if (fra) fra.focus({ preventScroll: true });
}
async function laeg(btn) {
  btn.classList.add('is-busy'); btn.disabled = true;
  try {
    await Cart.add({ id: btn.dataset.btVariant, quantity: 1 });
    try { await Cart.resetVariantsBeingAdded(); } catch (e) {}
    luk();
    const c = document.querySelector('.modal--cart, .popup--cart-notification');
    if (c && !c.shown && c.open) c.open(); else if (c && c.interval) { c.interval.reset(); c.interval.start(); }
  } catch (e) { console.warn('bt-qs', e); }
  btn.classList.remove('is-busy'); btn.disabled = false;
}
document.addEventListener('click', e => {
  const p = e.target.closest('[data-bt-qs]');
  if (p) { e.preventDefault(); e.stopPropagation(); aabn(p); return; }
  const v = e.target.closest('.bt-ark [data-bt-variant]');
  if (v) { e.preventDefault(); if (!v.disabled) laeg(v); return; }
  if (e.target.closest('[data-bt-luk]')) { e.preventDefault(); luk(); }
}, true);
document.addEventListener('keydown', e => { if (e.key === 'Escape') luk(); });
